module.exports = __webpack_public_path__ + "static/img/produtos_p.f3e35f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/tubaina-retro/produtos_p.png
// module id = qsQt
// module chunks = 0